import { createContext } from 'react';

export const GetStartedContext = createContext({
  currentStep: 0,
  // TODO: Probably better if we just create a type for this function
  // @ts-ignore Needed because otherwise tsc complains about params not being used
  nextStep: (skip = 1, shouldReplace = false) => {}, // eslint-disable-line @typescript-eslint/no-unused-vars -- Just defining what it gets, it is noop here
});
